/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AdminGuardedRouteImport } from './routes/_adminGuarded'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthSignUpRouteImport } from './routes/auth/sign-up'
import { Route as AuthSignInRouteImport } from './routes/auth/sign-in'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedPlayWithTrackerRouteImport } from './routes/_authenticated/PlayWithTracker'
import { Route as AdminGuardedAdminIndexRouteImport } from './routes/_adminGuarded/admin/index'
import { Route as AuthenticatedLeaguesNewRouteImport } from './routes/_authenticated/leagues/new'
import { Route as AuthenticatedLeaguesJoinRouteImport } from './routes/_authenticated/leagues/join'
import { Route as AdminGuardedAdminScoringRouteImport } from './routes/_adminGuarded/admin/scoring'
import { Route as AdminGuardedAdminLeaguesRouteImport } from './routes/_adminGuarded/admin/leagues'
import { Route as AdminGuardedAdminHistoricalStatsRouteImport } from './routes/_adminGuarded/admin/historical-stats'
import { Route as AdminGuardedAdminAnalyticsRouteImport } from './routes/_adminGuarded/admin/analytics'
import { Route as AuthenticatedLeaguesLeagueIdIndexRouteImport } from './routes/_authenticated/leagues/$leagueId/index'
import { Route as AdminGuardedAdminPlayersIndexRouteImport } from './routes/_adminGuarded/admin/players/index'
import { Route as AdminGuardedAdminLeaguesIndexRouteImport } from './routes/_adminGuarded/admin/leagues/index'
import { Route as AdminGuardedAdminGamesIndexRouteImport } from './routes/_adminGuarded/admin/games/index'
import { Route as AuthenticatedLeaguesLeagueIdTradesRouteImport } from './routes/_authenticated/leagues/$leagueId/trades'
import { Route as AuthenticatedLeaguesLeagueIdStandingsRouteImport } from './routes/_authenticated/leagues/$leagueId/standings'
import { Route as AuthenticatedLeaguesLeagueIdScoringRouteImport } from './routes/_authenticated/leagues/$leagueId/scoring'
import { Route as AuthenticatedLeaguesLeagueIdFreeAgentsRouteImport } from './routes/_authenticated/leagues/$leagueId/free-agents'
import { Route as AuthenticatedLeaguesLeagueIdDraftRouteImport } from './routes/_authenticated/leagues/$leagueId/draft'
import { Route as AdminGuardedAdminTeamsTeamIdRouteImport } from './routes/_adminGuarded/admin/teams/$teamId'
import { Route as AdminGuardedAdminPlayersPlayerIdRouteImport } from './routes/_adminGuarded/admin/players/$playerId'
import { Route as AdminGuardedAdminLeaguesLeagueIdRouteImport } from './routes/_adminGuarded/admin/leagues/$leagueId'
import { Route as AdminGuardedAdminGamesGameIdRouteImport } from './routes/_adminGuarded/admin/games/$gameId'
import { Route as AuthenticatedLeaguesLeagueIdPlayersIndexRouteImport } from './routes/_authenticated/leagues/$leagueId/players/index'
import { Route as AuthenticatedLeaguesLeagueIdGamesIndexRouteImport } from './routes/_authenticated/leagues/$leagueId/games/index'
import { Route as AuthenticatedLeaguesLeagueIdPlayersContributionsRouteImport } from './routes/_authenticated/leagues/$leagueId/players/contributions'
import { Route as AuthenticatedLeaguesLeagueIdPlayersAllRouteImport } from './routes/_authenticated/leagues/$leagueId/players/all'
import { Route as AuthenticatedLeaguesLeagueIdPlayersPlayerIdRouteImport } from './routes/_authenticated/leagues/$leagueId/players/$playerId'
import { Route as AuthenticatedLeaguesLeagueIdManagersMemberIdRouteImport } from './routes/_authenticated/leagues/$leagueId/managers/$memberId'
import { Route as AuthenticatedLeaguesLeagueIdGamesGameIdRouteImport } from './routes/_authenticated/leagues/$leagueId/games/$gameId'
import { Route as AuthenticatedLeaguesLeagueIdPlayersPlayerIdHistoryRouteImport } from './routes/_authenticated/leagues/$leagueId/players/$playerId_.history'
import { Route as AuthenticatedLeaguesLeagueIdManagersMemberIdContributionsRouteImport } from './routes/_authenticated/leagues/$leagueId/managers/$memberId/contributions'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminGuardedRoute = AdminGuardedRouteImport.update({
  id: '/_adminGuarded',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/auth/sign-up',
  path: '/auth/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/admin/login',
  path: '/admin/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPlayWithTrackerRoute =
  AuthenticatedPlayWithTrackerRouteImport.update({
    id: '/PlayWithTracker',
    path: '/PlayWithTracker',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AdminGuardedAdminIndexRoute = AdminGuardedAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AdminGuardedRoute,
} as any)
const AuthenticatedLeaguesNewRoute = AuthenticatedLeaguesNewRouteImport.update({
  id: '/leagues/new',
  path: '/leagues/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLeaguesJoinRoute =
  AuthenticatedLeaguesJoinRouteImport.update({
    id: '/leagues/join',
    path: '/leagues/join',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AdminGuardedAdminScoringRoute =
  AdminGuardedAdminScoringRouteImport.update({
    id: '/admin/scoring',
    path: '/admin/scoring',
    getParentRoute: () => AdminGuardedRoute,
  } as any)
const AdminGuardedAdminLeaguesRoute =
  AdminGuardedAdminLeaguesRouteImport.update({
    id: '/admin/leagues',
    path: '/admin/leagues',
    getParentRoute: () => AdminGuardedRoute,
  } as any)
const AdminGuardedAdminHistoricalStatsRoute =
  AdminGuardedAdminHistoricalStatsRouteImport.update({
    id: '/admin/historical-stats',
    path: '/admin/historical-stats',
    getParentRoute: () => AdminGuardedRoute,
  } as any)
const AdminGuardedAdminAnalyticsRoute =
  AdminGuardedAdminAnalyticsRouteImport.update({
    id: '/admin/analytics',
    path: '/admin/analytics',
    getParentRoute: () => AdminGuardedRoute,
  } as any)
const AuthenticatedLeaguesLeagueIdIndexRoute =
  AuthenticatedLeaguesLeagueIdIndexRouteImport.update({
    id: '/leagues/$leagueId/',
    path: '/leagues/$leagueId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AdminGuardedAdminPlayersIndexRoute =
  AdminGuardedAdminPlayersIndexRouteImport.update({
    id: '/admin/players/',
    path: '/admin/players/',
    getParentRoute: () => AdminGuardedRoute,
  } as any)
const AdminGuardedAdminLeaguesIndexRoute =
  AdminGuardedAdminLeaguesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminGuardedAdminLeaguesRoute,
  } as any)
const AdminGuardedAdminGamesIndexRoute =
  AdminGuardedAdminGamesIndexRouteImport.update({
    id: '/admin/games/',
    path: '/admin/games/',
    getParentRoute: () => AdminGuardedRoute,
  } as any)
const AuthenticatedLeaguesLeagueIdTradesRoute =
  AuthenticatedLeaguesLeagueIdTradesRouteImport.update({
    id: '/leagues/$leagueId/trades',
    path: '/leagues/$leagueId/trades',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeaguesLeagueIdStandingsRoute =
  AuthenticatedLeaguesLeagueIdStandingsRouteImport.update({
    id: '/leagues/$leagueId/standings',
    path: '/leagues/$leagueId/standings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeaguesLeagueIdScoringRoute =
  AuthenticatedLeaguesLeagueIdScoringRouteImport.update({
    id: '/leagues/$leagueId/scoring',
    path: '/leagues/$leagueId/scoring',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeaguesLeagueIdFreeAgentsRoute =
  AuthenticatedLeaguesLeagueIdFreeAgentsRouteImport.update({
    id: '/leagues/$leagueId/free-agents',
    path: '/leagues/$leagueId/free-agents',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeaguesLeagueIdDraftRoute =
  AuthenticatedLeaguesLeagueIdDraftRouteImport.update({
    id: '/leagues/$leagueId/draft',
    path: '/leagues/$leagueId/draft',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AdminGuardedAdminTeamsTeamIdRoute =
  AdminGuardedAdminTeamsTeamIdRouteImport.update({
    id: '/admin/teams/$teamId',
    path: '/admin/teams/$teamId',
    getParentRoute: () => AdminGuardedRoute,
  } as any)
const AdminGuardedAdminPlayersPlayerIdRoute =
  AdminGuardedAdminPlayersPlayerIdRouteImport.update({
    id: '/admin/players/$playerId',
    path: '/admin/players/$playerId',
    getParentRoute: () => AdminGuardedRoute,
  } as any)
const AdminGuardedAdminLeaguesLeagueIdRoute =
  AdminGuardedAdminLeaguesLeagueIdRouteImport.update({
    id: '/$leagueId',
    path: '/$leagueId',
    getParentRoute: () => AdminGuardedAdminLeaguesRoute,
  } as any)
const AdminGuardedAdminGamesGameIdRoute =
  AdminGuardedAdminGamesGameIdRouteImport.update({
    id: '/admin/games/$gameId',
    path: '/admin/games/$gameId',
    getParentRoute: () => AdminGuardedRoute,
  } as any)
const AuthenticatedLeaguesLeagueIdPlayersIndexRoute =
  AuthenticatedLeaguesLeagueIdPlayersIndexRouteImport.update({
    id: '/leagues/$leagueId/players/',
    path: '/leagues/$leagueId/players/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeaguesLeagueIdGamesIndexRoute =
  AuthenticatedLeaguesLeagueIdGamesIndexRouteImport.update({
    id: '/leagues/$leagueId/games/',
    path: '/leagues/$leagueId/games/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeaguesLeagueIdPlayersContributionsRoute =
  AuthenticatedLeaguesLeagueIdPlayersContributionsRouteImport.update({
    id: '/leagues/$leagueId/players/contributions',
    path: '/leagues/$leagueId/players/contributions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeaguesLeagueIdPlayersAllRoute =
  AuthenticatedLeaguesLeagueIdPlayersAllRouteImport.update({
    id: '/leagues/$leagueId/players/all',
    path: '/leagues/$leagueId/players/all',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeaguesLeagueIdPlayersPlayerIdRoute =
  AuthenticatedLeaguesLeagueIdPlayersPlayerIdRouteImport.update({
    id: '/leagues/$leagueId/players/$playerId',
    path: '/leagues/$leagueId/players/$playerId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeaguesLeagueIdManagersMemberIdRoute =
  AuthenticatedLeaguesLeagueIdManagersMemberIdRouteImport.update({
    id: '/leagues/$leagueId/managers/$memberId',
    path: '/leagues/$leagueId/managers/$memberId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeaguesLeagueIdGamesGameIdRoute =
  AuthenticatedLeaguesLeagueIdGamesGameIdRouteImport.update({
    id: '/leagues/$leagueId/games/$gameId',
    path: '/leagues/$leagueId/games/$gameId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeaguesLeagueIdPlayersPlayerIdHistoryRoute =
  AuthenticatedLeaguesLeagueIdPlayersPlayerIdHistoryRouteImport.update({
    id: '/leagues/$leagueId/players/$playerId_/history',
    path: '/leagues/$leagueId/players/$playerId/history',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeaguesLeagueIdManagersMemberIdContributionsRoute =
  AuthenticatedLeaguesLeagueIdManagersMemberIdContributionsRouteImport.update({
    id: '/contributions',
    path: '/contributions',
    getParentRoute: () => AuthenticatedLeaguesLeagueIdManagersMemberIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/PlayWithTracker': typeof AuthenticatedPlayWithTrackerRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/admin/login': typeof AdminLoginRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/admin/analytics': typeof AdminGuardedAdminAnalyticsRoute
  '/admin/historical-stats': typeof AdminGuardedAdminHistoricalStatsRoute
  '/admin/leagues': typeof AdminGuardedAdminLeaguesRouteWithChildren
  '/admin/scoring': typeof AdminGuardedAdminScoringRoute
  '/leagues/join': typeof AuthenticatedLeaguesJoinRoute
  '/leagues/new': typeof AuthenticatedLeaguesNewRoute
  '/admin/': typeof AdminGuardedAdminIndexRoute
  '/admin/games/$gameId': typeof AdminGuardedAdminGamesGameIdRoute
  '/admin/leagues/$leagueId': typeof AdminGuardedAdminLeaguesLeagueIdRoute
  '/admin/players/$playerId': typeof AdminGuardedAdminPlayersPlayerIdRoute
  '/admin/teams/$teamId': typeof AdminGuardedAdminTeamsTeamIdRoute
  '/leagues/$leagueId/draft': typeof AuthenticatedLeaguesLeagueIdDraftRoute
  '/leagues/$leagueId/free-agents': typeof AuthenticatedLeaguesLeagueIdFreeAgentsRoute
  '/leagues/$leagueId/scoring': typeof AuthenticatedLeaguesLeagueIdScoringRoute
  '/leagues/$leagueId/standings': typeof AuthenticatedLeaguesLeagueIdStandingsRoute
  '/leagues/$leagueId/trades': typeof AuthenticatedLeaguesLeagueIdTradesRoute
  '/admin/games/': typeof AdminGuardedAdminGamesIndexRoute
  '/admin/leagues/': typeof AdminGuardedAdminLeaguesIndexRoute
  '/admin/players/': typeof AdminGuardedAdminPlayersIndexRoute
  '/leagues/$leagueId/': typeof AuthenticatedLeaguesLeagueIdIndexRoute
  '/leagues/$leagueId/games/$gameId': typeof AuthenticatedLeaguesLeagueIdGamesGameIdRoute
  '/leagues/$leagueId/managers/$memberId': typeof AuthenticatedLeaguesLeagueIdManagersMemberIdRouteWithChildren
  '/leagues/$leagueId/players/$playerId': typeof AuthenticatedLeaguesLeagueIdPlayersPlayerIdRoute
  '/leagues/$leagueId/players/all': typeof AuthenticatedLeaguesLeagueIdPlayersAllRoute
  '/leagues/$leagueId/players/contributions': typeof AuthenticatedLeaguesLeagueIdPlayersContributionsRoute
  '/leagues/$leagueId/games/': typeof AuthenticatedLeaguesLeagueIdGamesIndexRoute
  '/leagues/$leagueId/players/': typeof AuthenticatedLeaguesLeagueIdPlayersIndexRoute
  '/leagues/$leagueId/managers/$memberId/contributions': typeof AuthenticatedLeaguesLeagueIdManagersMemberIdContributionsRoute
  '/leagues/$leagueId/players/$playerId/history': typeof AuthenticatedLeaguesLeagueIdPlayersPlayerIdHistoryRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/PlayWithTracker': typeof AuthenticatedPlayWithTrackerRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/admin/login': typeof AdminLoginRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/admin/analytics': typeof AdminGuardedAdminAnalyticsRoute
  '/admin/historical-stats': typeof AdminGuardedAdminHistoricalStatsRoute
  '/admin/scoring': typeof AdminGuardedAdminScoringRoute
  '/leagues/join': typeof AuthenticatedLeaguesJoinRoute
  '/leagues/new': typeof AuthenticatedLeaguesNewRoute
  '/admin': typeof AdminGuardedAdminIndexRoute
  '/admin/games/$gameId': typeof AdminGuardedAdminGamesGameIdRoute
  '/admin/leagues/$leagueId': typeof AdminGuardedAdminLeaguesLeagueIdRoute
  '/admin/players/$playerId': typeof AdminGuardedAdminPlayersPlayerIdRoute
  '/admin/teams/$teamId': typeof AdminGuardedAdminTeamsTeamIdRoute
  '/leagues/$leagueId/draft': typeof AuthenticatedLeaguesLeagueIdDraftRoute
  '/leagues/$leagueId/free-agents': typeof AuthenticatedLeaguesLeagueIdFreeAgentsRoute
  '/leagues/$leagueId/scoring': typeof AuthenticatedLeaguesLeagueIdScoringRoute
  '/leagues/$leagueId/standings': typeof AuthenticatedLeaguesLeagueIdStandingsRoute
  '/leagues/$leagueId/trades': typeof AuthenticatedLeaguesLeagueIdTradesRoute
  '/admin/games': typeof AdminGuardedAdminGamesIndexRoute
  '/admin/leagues': typeof AdminGuardedAdminLeaguesIndexRoute
  '/admin/players': typeof AdminGuardedAdminPlayersIndexRoute
  '/leagues/$leagueId': typeof AuthenticatedLeaguesLeagueIdIndexRoute
  '/leagues/$leagueId/games/$gameId': typeof AuthenticatedLeaguesLeagueIdGamesGameIdRoute
  '/leagues/$leagueId/managers/$memberId': typeof AuthenticatedLeaguesLeagueIdManagersMemberIdRouteWithChildren
  '/leagues/$leagueId/players/$playerId': typeof AuthenticatedLeaguesLeagueIdPlayersPlayerIdRoute
  '/leagues/$leagueId/players/all': typeof AuthenticatedLeaguesLeagueIdPlayersAllRoute
  '/leagues/$leagueId/players/contributions': typeof AuthenticatedLeaguesLeagueIdPlayersContributionsRoute
  '/leagues/$leagueId/games': typeof AuthenticatedLeaguesLeagueIdGamesIndexRoute
  '/leagues/$leagueId/players': typeof AuthenticatedLeaguesLeagueIdPlayersIndexRoute
  '/leagues/$leagueId/managers/$memberId/contributions': typeof AuthenticatedLeaguesLeagueIdManagersMemberIdContributionsRoute
  '/leagues/$leagueId/players/$playerId/history': typeof AuthenticatedLeaguesLeagueIdPlayersPlayerIdHistoryRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_adminGuarded': typeof AdminGuardedRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/PlayWithTracker': typeof AuthenticatedPlayWithTrackerRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/admin/login': typeof AdminLoginRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_adminGuarded/admin/analytics': typeof AdminGuardedAdminAnalyticsRoute
  '/_adminGuarded/admin/historical-stats': typeof AdminGuardedAdminHistoricalStatsRoute
  '/_adminGuarded/admin/leagues': typeof AdminGuardedAdminLeaguesRouteWithChildren
  '/_adminGuarded/admin/scoring': typeof AdminGuardedAdminScoringRoute
  '/_authenticated/leagues/join': typeof AuthenticatedLeaguesJoinRoute
  '/_authenticated/leagues/new': typeof AuthenticatedLeaguesNewRoute
  '/_adminGuarded/admin/': typeof AdminGuardedAdminIndexRoute
  '/_adminGuarded/admin/games/$gameId': typeof AdminGuardedAdminGamesGameIdRoute
  '/_adminGuarded/admin/leagues/$leagueId': typeof AdminGuardedAdminLeaguesLeagueIdRoute
  '/_adminGuarded/admin/players/$playerId': typeof AdminGuardedAdminPlayersPlayerIdRoute
  '/_adminGuarded/admin/teams/$teamId': typeof AdminGuardedAdminTeamsTeamIdRoute
  '/_authenticated/leagues/$leagueId/draft': typeof AuthenticatedLeaguesLeagueIdDraftRoute
  '/_authenticated/leagues/$leagueId/free-agents': typeof AuthenticatedLeaguesLeagueIdFreeAgentsRoute
  '/_authenticated/leagues/$leagueId/scoring': typeof AuthenticatedLeaguesLeagueIdScoringRoute
  '/_authenticated/leagues/$leagueId/standings': typeof AuthenticatedLeaguesLeagueIdStandingsRoute
  '/_authenticated/leagues/$leagueId/trades': typeof AuthenticatedLeaguesLeagueIdTradesRoute
  '/_adminGuarded/admin/games/': typeof AdminGuardedAdminGamesIndexRoute
  '/_adminGuarded/admin/leagues/': typeof AdminGuardedAdminLeaguesIndexRoute
  '/_adminGuarded/admin/players/': typeof AdminGuardedAdminPlayersIndexRoute
  '/_authenticated/leagues/$leagueId/': typeof AuthenticatedLeaguesLeagueIdIndexRoute
  '/_authenticated/leagues/$leagueId/games/$gameId': typeof AuthenticatedLeaguesLeagueIdGamesGameIdRoute
  '/_authenticated/leagues/$leagueId/managers/$memberId': typeof AuthenticatedLeaguesLeagueIdManagersMemberIdRouteWithChildren
  '/_authenticated/leagues/$leagueId/players/$playerId': typeof AuthenticatedLeaguesLeagueIdPlayersPlayerIdRoute
  '/_authenticated/leagues/$leagueId/players/all': typeof AuthenticatedLeaguesLeagueIdPlayersAllRoute
  '/_authenticated/leagues/$leagueId/players/contributions': typeof AuthenticatedLeaguesLeagueIdPlayersContributionsRoute
  '/_authenticated/leagues/$leagueId/games/': typeof AuthenticatedLeaguesLeagueIdGamesIndexRoute
  '/_authenticated/leagues/$leagueId/players/': typeof AuthenticatedLeaguesLeagueIdPlayersIndexRoute
  '/_authenticated/leagues/$leagueId/managers/$memberId/contributions': typeof AuthenticatedLeaguesLeagueIdManagersMemberIdContributionsRoute
  '/_authenticated/leagues/$leagueId/players/$playerId_/history': typeof AuthenticatedLeaguesLeagueIdPlayersPlayerIdHistoryRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/PlayWithTracker'
    | '/settings'
    | '/admin/login'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/admin/analytics'
    | '/admin/historical-stats'
    | '/admin/leagues'
    | '/admin/scoring'
    | '/leagues/join'
    | '/leagues/new'
    | '/admin/'
    | '/admin/games/$gameId'
    | '/admin/leagues/$leagueId'
    | '/admin/players/$playerId'
    | '/admin/teams/$teamId'
    | '/leagues/$leagueId/draft'
    | '/leagues/$leagueId/free-agents'
    | '/leagues/$leagueId/scoring'
    | '/leagues/$leagueId/standings'
    | '/leagues/$leagueId/trades'
    | '/admin/games/'
    | '/admin/leagues/'
    | '/admin/players/'
    | '/leagues/$leagueId/'
    | '/leagues/$leagueId/games/$gameId'
    | '/leagues/$leagueId/managers/$memberId'
    | '/leagues/$leagueId/players/$playerId'
    | '/leagues/$leagueId/players/all'
    | '/leagues/$leagueId/players/contributions'
    | '/leagues/$leagueId/games/'
    | '/leagues/$leagueId/players/'
    | '/leagues/$leagueId/managers/$memberId/contributions'
    | '/leagues/$leagueId/players/$playerId/history'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/PlayWithTracker'
    | '/settings'
    | '/admin/login'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/admin/analytics'
    | '/admin/historical-stats'
    | '/admin/scoring'
    | '/leagues/join'
    | '/leagues/new'
    | '/admin'
    | '/admin/games/$gameId'
    | '/admin/leagues/$leagueId'
    | '/admin/players/$playerId'
    | '/admin/teams/$teamId'
    | '/leagues/$leagueId/draft'
    | '/leagues/$leagueId/free-agents'
    | '/leagues/$leagueId/scoring'
    | '/leagues/$leagueId/standings'
    | '/leagues/$leagueId/trades'
    | '/admin/games'
    | '/admin/leagues'
    | '/admin/players'
    | '/leagues/$leagueId'
    | '/leagues/$leagueId/games/$gameId'
    | '/leagues/$leagueId/managers/$memberId'
    | '/leagues/$leagueId/players/$playerId'
    | '/leagues/$leagueId/players/all'
    | '/leagues/$leagueId/players/contributions'
    | '/leagues/$leagueId/games'
    | '/leagues/$leagueId/players'
    | '/leagues/$leagueId/managers/$memberId/contributions'
    | '/leagues/$leagueId/players/$playerId/history'
  id:
    | '__root__'
    | '/_adminGuarded'
    | '/_authenticated'
    | '/_authenticated/PlayWithTracker'
    | '/_authenticated/settings'
    | '/admin/login'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/_authenticated/'
    | '/_adminGuarded/admin/analytics'
    | '/_adminGuarded/admin/historical-stats'
    | '/_adminGuarded/admin/leagues'
    | '/_adminGuarded/admin/scoring'
    | '/_authenticated/leagues/join'
    | '/_authenticated/leagues/new'
    | '/_adminGuarded/admin/'
    | '/_adminGuarded/admin/games/$gameId'
    | '/_adminGuarded/admin/leagues/$leagueId'
    | '/_adminGuarded/admin/players/$playerId'
    | '/_adminGuarded/admin/teams/$teamId'
    | '/_authenticated/leagues/$leagueId/draft'
    | '/_authenticated/leagues/$leagueId/free-agents'
    | '/_authenticated/leagues/$leagueId/scoring'
    | '/_authenticated/leagues/$leagueId/standings'
    | '/_authenticated/leagues/$leagueId/trades'
    | '/_adminGuarded/admin/games/'
    | '/_adminGuarded/admin/leagues/'
    | '/_adminGuarded/admin/players/'
    | '/_authenticated/leagues/$leagueId/'
    | '/_authenticated/leagues/$leagueId/games/$gameId'
    | '/_authenticated/leagues/$leagueId/managers/$memberId'
    | '/_authenticated/leagues/$leagueId/players/$playerId'
    | '/_authenticated/leagues/$leagueId/players/all'
    | '/_authenticated/leagues/$leagueId/players/contributions'
    | '/_authenticated/leagues/$leagueId/games/'
    | '/_authenticated/leagues/$leagueId/players/'
    | '/_authenticated/leagues/$leagueId/managers/$memberId/contributions'
    | '/_authenticated/leagues/$leagueId/players/$playerId_/history'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AdminGuardedRoute: typeof AdminGuardedRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AdminLoginRoute: typeof AdminLoginRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_adminGuarded': {
      id: '/_adminGuarded'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminGuardedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/admin/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/PlayWithTracker': {
      id: '/_authenticated/PlayWithTracker'
      path: '/PlayWithTracker'
      fullPath: '/PlayWithTracker'
      preLoaderRoute: typeof AuthenticatedPlayWithTrackerRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_adminGuarded/admin/': {
      id: '/_adminGuarded/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminGuardedAdminIndexRouteImport
      parentRoute: typeof AdminGuardedRoute
    }
    '/_authenticated/leagues/new': {
      id: '/_authenticated/leagues/new'
      path: '/leagues/new'
      fullPath: '/leagues/new'
      preLoaderRoute: typeof AuthenticatedLeaguesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leagues/join': {
      id: '/_authenticated/leagues/join'
      path: '/leagues/join'
      fullPath: '/leagues/join'
      preLoaderRoute: typeof AuthenticatedLeaguesJoinRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_adminGuarded/admin/scoring': {
      id: '/_adminGuarded/admin/scoring'
      path: '/admin/scoring'
      fullPath: '/admin/scoring'
      preLoaderRoute: typeof AdminGuardedAdminScoringRouteImport
      parentRoute: typeof AdminGuardedRoute
    }
    '/_adminGuarded/admin/leagues': {
      id: '/_adminGuarded/admin/leagues'
      path: '/admin/leagues'
      fullPath: '/admin/leagues'
      preLoaderRoute: typeof AdminGuardedAdminLeaguesRouteImport
      parentRoute: typeof AdminGuardedRoute
    }
    '/_adminGuarded/admin/historical-stats': {
      id: '/_adminGuarded/admin/historical-stats'
      path: '/admin/historical-stats'
      fullPath: '/admin/historical-stats'
      preLoaderRoute: typeof AdminGuardedAdminHistoricalStatsRouteImport
      parentRoute: typeof AdminGuardedRoute
    }
    '/_adminGuarded/admin/analytics': {
      id: '/_adminGuarded/admin/analytics'
      path: '/admin/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminGuardedAdminAnalyticsRouteImport
      parentRoute: typeof AdminGuardedRoute
    }
    '/_authenticated/leagues/$leagueId/': {
      id: '/_authenticated/leagues/$leagueId/'
      path: '/leagues/$leagueId'
      fullPath: '/leagues/$leagueId/'
      preLoaderRoute: typeof AuthenticatedLeaguesLeagueIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_adminGuarded/admin/players/': {
      id: '/_adminGuarded/admin/players/'
      path: '/admin/players'
      fullPath: '/admin/players/'
      preLoaderRoute: typeof AdminGuardedAdminPlayersIndexRouteImport
      parentRoute: typeof AdminGuardedRoute
    }
    '/_adminGuarded/admin/leagues/': {
      id: '/_adminGuarded/admin/leagues/'
      path: '/'
      fullPath: '/admin/leagues/'
      preLoaderRoute: typeof AdminGuardedAdminLeaguesIndexRouteImport
      parentRoute: typeof AdminGuardedAdminLeaguesRoute
    }
    '/_adminGuarded/admin/games/': {
      id: '/_adminGuarded/admin/games/'
      path: '/admin/games'
      fullPath: '/admin/games/'
      preLoaderRoute: typeof AdminGuardedAdminGamesIndexRouteImport
      parentRoute: typeof AdminGuardedRoute
    }
    '/_authenticated/leagues/$leagueId/trades': {
      id: '/_authenticated/leagues/$leagueId/trades'
      path: '/leagues/$leagueId/trades'
      fullPath: '/leagues/$leagueId/trades'
      preLoaderRoute: typeof AuthenticatedLeaguesLeagueIdTradesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leagues/$leagueId/standings': {
      id: '/_authenticated/leagues/$leagueId/standings'
      path: '/leagues/$leagueId/standings'
      fullPath: '/leagues/$leagueId/standings'
      preLoaderRoute: typeof AuthenticatedLeaguesLeagueIdStandingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leagues/$leagueId/scoring': {
      id: '/_authenticated/leagues/$leagueId/scoring'
      path: '/leagues/$leagueId/scoring'
      fullPath: '/leagues/$leagueId/scoring'
      preLoaderRoute: typeof AuthenticatedLeaguesLeagueIdScoringRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leagues/$leagueId/free-agents': {
      id: '/_authenticated/leagues/$leagueId/free-agents'
      path: '/leagues/$leagueId/free-agents'
      fullPath: '/leagues/$leagueId/free-agents'
      preLoaderRoute: typeof AuthenticatedLeaguesLeagueIdFreeAgentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leagues/$leagueId/draft': {
      id: '/_authenticated/leagues/$leagueId/draft'
      path: '/leagues/$leagueId/draft'
      fullPath: '/leagues/$leagueId/draft'
      preLoaderRoute: typeof AuthenticatedLeaguesLeagueIdDraftRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_adminGuarded/admin/teams/$teamId': {
      id: '/_adminGuarded/admin/teams/$teamId'
      path: '/admin/teams/$teamId'
      fullPath: '/admin/teams/$teamId'
      preLoaderRoute: typeof AdminGuardedAdminTeamsTeamIdRouteImport
      parentRoute: typeof AdminGuardedRoute
    }
    '/_adminGuarded/admin/players/$playerId': {
      id: '/_adminGuarded/admin/players/$playerId'
      path: '/admin/players/$playerId'
      fullPath: '/admin/players/$playerId'
      preLoaderRoute: typeof AdminGuardedAdminPlayersPlayerIdRouteImport
      parentRoute: typeof AdminGuardedRoute
    }
    '/_adminGuarded/admin/leagues/$leagueId': {
      id: '/_adminGuarded/admin/leagues/$leagueId'
      path: '/$leagueId'
      fullPath: '/admin/leagues/$leagueId'
      preLoaderRoute: typeof AdminGuardedAdminLeaguesLeagueIdRouteImport
      parentRoute: typeof AdminGuardedAdminLeaguesRoute
    }
    '/_adminGuarded/admin/games/$gameId': {
      id: '/_adminGuarded/admin/games/$gameId'
      path: '/admin/games/$gameId'
      fullPath: '/admin/games/$gameId'
      preLoaderRoute: typeof AdminGuardedAdminGamesGameIdRouteImport
      parentRoute: typeof AdminGuardedRoute
    }
    '/_authenticated/leagues/$leagueId/players/': {
      id: '/_authenticated/leagues/$leagueId/players/'
      path: '/leagues/$leagueId/players'
      fullPath: '/leagues/$leagueId/players/'
      preLoaderRoute: typeof AuthenticatedLeaguesLeagueIdPlayersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leagues/$leagueId/games/': {
      id: '/_authenticated/leagues/$leagueId/games/'
      path: '/leagues/$leagueId/games'
      fullPath: '/leagues/$leagueId/games/'
      preLoaderRoute: typeof AuthenticatedLeaguesLeagueIdGamesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leagues/$leagueId/players/contributions': {
      id: '/_authenticated/leagues/$leagueId/players/contributions'
      path: '/leagues/$leagueId/players/contributions'
      fullPath: '/leagues/$leagueId/players/contributions'
      preLoaderRoute: typeof AuthenticatedLeaguesLeagueIdPlayersContributionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leagues/$leagueId/players/all': {
      id: '/_authenticated/leagues/$leagueId/players/all'
      path: '/leagues/$leagueId/players/all'
      fullPath: '/leagues/$leagueId/players/all'
      preLoaderRoute: typeof AuthenticatedLeaguesLeagueIdPlayersAllRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leagues/$leagueId/players/$playerId': {
      id: '/_authenticated/leagues/$leagueId/players/$playerId'
      path: '/leagues/$leagueId/players/$playerId'
      fullPath: '/leagues/$leagueId/players/$playerId'
      preLoaderRoute: typeof AuthenticatedLeaguesLeagueIdPlayersPlayerIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leagues/$leagueId/managers/$memberId': {
      id: '/_authenticated/leagues/$leagueId/managers/$memberId'
      path: '/leagues/$leagueId/managers/$memberId'
      fullPath: '/leagues/$leagueId/managers/$memberId'
      preLoaderRoute: typeof AuthenticatedLeaguesLeagueIdManagersMemberIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leagues/$leagueId/games/$gameId': {
      id: '/_authenticated/leagues/$leagueId/games/$gameId'
      path: '/leagues/$leagueId/games/$gameId'
      fullPath: '/leagues/$leagueId/games/$gameId'
      preLoaderRoute: typeof AuthenticatedLeaguesLeagueIdGamesGameIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leagues/$leagueId/players/$playerId_/history': {
      id: '/_authenticated/leagues/$leagueId/players/$playerId_/history'
      path: '/leagues/$leagueId/players/$playerId/history'
      fullPath: '/leagues/$leagueId/players/$playerId/history'
      preLoaderRoute: typeof AuthenticatedLeaguesLeagueIdPlayersPlayerIdHistoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leagues/$leagueId/managers/$memberId/contributions': {
      id: '/_authenticated/leagues/$leagueId/managers/$memberId/contributions'
      path: '/contributions'
      fullPath: '/leagues/$leagueId/managers/$memberId/contributions'
      preLoaderRoute: typeof AuthenticatedLeaguesLeagueIdManagersMemberIdContributionsRouteImport
      parentRoute: typeof AuthenticatedLeaguesLeagueIdManagersMemberIdRoute
    }
  }
}

interface AdminGuardedAdminLeaguesRouteChildren {
  AdminGuardedAdminLeaguesLeagueIdRoute: typeof AdminGuardedAdminLeaguesLeagueIdRoute
  AdminGuardedAdminLeaguesIndexRoute: typeof AdminGuardedAdminLeaguesIndexRoute
}

const AdminGuardedAdminLeaguesRouteChildren: AdminGuardedAdminLeaguesRouteChildren =
  {
    AdminGuardedAdminLeaguesLeagueIdRoute:
      AdminGuardedAdminLeaguesLeagueIdRoute,
    AdminGuardedAdminLeaguesIndexRoute: AdminGuardedAdminLeaguesIndexRoute,
  }

const AdminGuardedAdminLeaguesRouteWithChildren =
  AdminGuardedAdminLeaguesRoute._addFileChildren(
    AdminGuardedAdminLeaguesRouteChildren,
  )

interface AdminGuardedRouteChildren {
  AdminGuardedAdminAnalyticsRoute: typeof AdminGuardedAdminAnalyticsRoute
  AdminGuardedAdminHistoricalStatsRoute: typeof AdminGuardedAdminHistoricalStatsRoute
  AdminGuardedAdminLeaguesRoute: typeof AdminGuardedAdminLeaguesRouteWithChildren
  AdminGuardedAdminScoringRoute: typeof AdminGuardedAdminScoringRoute
  AdminGuardedAdminIndexRoute: typeof AdminGuardedAdminIndexRoute
  AdminGuardedAdminGamesGameIdRoute: typeof AdminGuardedAdminGamesGameIdRoute
  AdminGuardedAdminPlayersPlayerIdRoute: typeof AdminGuardedAdminPlayersPlayerIdRoute
  AdminGuardedAdminTeamsTeamIdRoute: typeof AdminGuardedAdminTeamsTeamIdRoute
  AdminGuardedAdminGamesIndexRoute: typeof AdminGuardedAdminGamesIndexRoute
  AdminGuardedAdminPlayersIndexRoute: typeof AdminGuardedAdminPlayersIndexRoute
}

const AdminGuardedRouteChildren: AdminGuardedRouteChildren = {
  AdminGuardedAdminAnalyticsRoute: AdminGuardedAdminAnalyticsRoute,
  AdminGuardedAdminHistoricalStatsRoute: AdminGuardedAdminHistoricalStatsRoute,
  AdminGuardedAdminLeaguesRoute: AdminGuardedAdminLeaguesRouteWithChildren,
  AdminGuardedAdminScoringRoute: AdminGuardedAdminScoringRoute,
  AdminGuardedAdminIndexRoute: AdminGuardedAdminIndexRoute,
  AdminGuardedAdminGamesGameIdRoute: AdminGuardedAdminGamesGameIdRoute,
  AdminGuardedAdminPlayersPlayerIdRoute: AdminGuardedAdminPlayersPlayerIdRoute,
  AdminGuardedAdminTeamsTeamIdRoute: AdminGuardedAdminTeamsTeamIdRoute,
  AdminGuardedAdminGamesIndexRoute: AdminGuardedAdminGamesIndexRoute,
  AdminGuardedAdminPlayersIndexRoute: AdminGuardedAdminPlayersIndexRoute,
}

const AdminGuardedRouteWithChildren = AdminGuardedRoute._addFileChildren(
  AdminGuardedRouteChildren,
)

interface AuthenticatedLeaguesLeagueIdManagersMemberIdRouteChildren {
  AuthenticatedLeaguesLeagueIdManagersMemberIdContributionsRoute: typeof AuthenticatedLeaguesLeagueIdManagersMemberIdContributionsRoute
}

const AuthenticatedLeaguesLeagueIdManagersMemberIdRouteChildren: AuthenticatedLeaguesLeagueIdManagersMemberIdRouteChildren =
  {
    AuthenticatedLeaguesLeagueIdManagersMemberIdContributionsRoute:
      AuthenticatedLeaguesLeagueIdManagersMemberIdContributionsRoute,
  }

const AuthenticatedLeaguesLeagueIdManagersMemberIdRouteWithChildren =
  AuthenticatedLeaguesLeagueIdManagersMemberIdRoute._addFileChildren(
    AuthenticatedLeaguesLeagueIdManagersMemberIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedPlayWithTrackerRoute: typeof AuthenticatedPlayWithTrackerRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedLeaguesJoinRoute: typeof AuthenticatedLeaguesJoinRoute
  AuthenticatedLeaguesNewRoute: typeof AuthenticatedLeaguesNewRoute
  AuthenticatedLeaguesLeagueIdDraftRoute: typeof AuthenticatedLeaguesLeagueIdDraftRoute
  AuthenticatedLeaguesLeagueIdFreeAgentsRoute: typeof AuthenticatedLeaguesLeagueIdFreeAgentsRoute
  AuthenticatedLeaguesLeagueIdScoringRoute: typeof AuthenticatedLeaguesLeagueIdScoringRoute
  AuthenticatedLeaguesLeagueIdStandingsRoute: typeof AuthenticatedLeaguesLeagueIdStandingsRoute
  AuthenticatedLeaguesLeagueIdTradesRoute: typeof AuthenticatedLeaguesLeagueIdTradesRoute
  AuthenticatedLeaguesLeagueIdIndexRoute: typeof AuthenticatedLeaguesLeagueIdIndexRoute
  AuthenticatedLeaguesLeagueIdGamesGameIdRoute: typeof AuthenticatedLeaguesLeagueIdGamesGameIdRoute
  AuthenticatedLeaguesLeagueIdManagersMemberIdRoute: typeof AuthenticatedLeaguesLeagueIdManagersMemberIdRouteWithChildren
  AuthenticatedLeaguesLeagueIdPlayersPlayerIdRoute: typeof AuthenticatedLeaguesLeagueIdPlayersPlayerIdRoute
  AuthenticatedLeaguesLeagueIdPlayersAllRoute: typeof AuthenticatedLeaguesLeagueIdPlayersAllRoute
  AuthenticatedLeaguesLeagueIdPlayersContributionsRoute: typeof AuthenticatedLeaguesLeagueIdPlayersContributionsRoute
  AuthenticatedLeaguesLeagueIdGamesIndexRoute: typeof AuthenticatedLeaguesLeagueIdGamesIndexRoute
  AuthenticatedLeaguesLeagueIdPlayersIndexRoute: typeof AuthenticatedLeaguesLeagueIdPlayersIndexRoute
  AuthenticatedLeaguesLeagueIdPlayersPlayerIdHistoryRoute: typeof AuthenticatedLeaguesLeagueIdPlayersPlayerIdHistoryRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedPlayWithTrackerRoute: AuthenticatedPlayWithTrackerRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedLeaguesJoinRoute: AuthenticatedLeaguesJoinRoute,
  AuthenticatedLeaguesNewRoute: AuthenticatedLeaguesNewRoute,
  AuthenticatedLeaguesLeagueIdDraftRoute:
    AuthenticatedLeaguesLeagueIdDraftRoute,
  AuthenticatedLeaguesLeagueIdFreeAgentsRoute:
    AuthenticatedLeaguesLeagueIdFreeAgentsRoute,
  AuthenticatedLeaguesLeagueIdScoringRoute:
    AuthenticatedLeaguesLeagueIdScoringRoute,
  AuthenticatedLeaguesLeagueIdStandingsRoute:
    AuthenticatedLeaguesLeagueIdStandingsRoute,
  AuthenticatedLeaguesLeagueIdTradesRoute:
    AuthenticatedLeaguesLeagueIdTradesRoute,
  AuthenticatedLeaguesLeagueIdIndexRoute:
    AuthenticatedLeaguesLeagueIdIndexRoute,
  AuthenticatedLeaguesLeagueIdGamesGameIdRoute:
    AuthenticatedLeaguesLeagueIdGamesGameIdRoute,
  AuthenticatedLeaguesLeagueIdManagersMemberIdRoute:
    AuthenticatedLeaguesLeagueIdManagersMemberIdRouteWithChildren,
  AuthenticatedLeaguesLeagueIdPlayersPlayerIdRoute:
    AuthenticatedLeaguesLeagueIdPlayersPlayerIdRoute,
  AuthenticatedLeaguesLeagueIdPlayersAllRoute:
    AuthenticatedLeaguesLeagueIdPlayersAllRoute,
  AuthenticatedLeaguesLeagueIdPlayersContributionsRoute:
    AuthenticatedLeaguesLeagueIdPlayersContributionsRoute,
  AuthenticatedLeaguesLeagueIdGamesIndexRoute:
    AuthenticatedLeaguesLeagueIdGamesIndexRoute,
  AuthenticatedLeaguesLeagueIdPlayersIndexRoute:
    AuthenticatedLeaguesLeagueIdPlayersIndexRoute,
  AuthenticatedLeaguesLeagueIdPlayersPlayerIdHistoryRoute:
    AuthenticatedLeaguesLeagueIdPlayersPlayerIdHistoryRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AdminGuardedRoute: AdminGuardedRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AdminLoginRoute: AdminLoginRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
